module.exports = __webpack_public_path__ + "img/TIV_nettkurs_logo - Copy.2e8f262f.png";